import { render, staticRenderFns } from "./deal.vue?vue&type=template&id=1076ae55"
import script from "./deal.ts?vue&type=script&lang=js&external"
export * from "./deal.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports